import { CalloutBox } from "../../../../src/components/Docs/CalloutBox";
import Tab from "components/Tab";
import * as React from 'react';
export default {
  CalloutBox,
  Tab,
  React
};